<template>
    <a-modal title="尾款凭证？" :visible="visible" :confirmLoading="loading"  cancelText="取消" okText="确定"  @ok="handleOk" @cancel="handleCancel">
        <p>尾款凭证：{{ currentItem.endPay }}元 </p>
        <p>收款人：{{ bankInfo.receiver }}</p>
        <p>银行信息：{{ bankInfo.bankInformation }}</p>
        <p>银行账号：{{ bankInfo.bankAccount }}</p>
        <upload ref="upload" :imageUrl="imageUrl" @getFile="getFile"></upload>
    </a-modal>
</template>
<script>
import upload from '@/components/uploadnomu.vue'
export default {
    components:{
        upload
    },
    data(){
        return{
            visible:false,
            currentItem:{},
            loading:false,
            imageUrl:'',
            bankInfo:'',
        }
    },
    created(){
        this.$https.get('/system/bank/bankList').then(res=>{
            if(res.code == 200){
                this.bankInfo = res.rows[0];
            }else{
                this.$message.error('获取失败')
            }
        })
    },
    methods:{
        showDialog(row){
            this.currentItem = row;
            this.visible = true;
        },
        handleOk(){
            if(!this.imageUrl){
                this.$message.info('请上传附件')
            }else{
                this.uploadNote(this.imageUrl);
            }
        },
        uploadNote(url){ 
            let obj = {};
            obj = {
                endPayUrl:url,
                id:this.currentItem.id
            }
            this.loading = true;
            this.$https.post('/portal/bidding/uploadEndPay',obj).then(res=>{
                   if(res.code == 200){
                      this.loading = false;
                      this.visible = false;
                      this.$message.success('上传成功');
                      this.$emit('getList')
                   }
            }).catch(error=>{
                  this.loading = false;
            })
        },
        handleCancel(){
           this.visible = false;
        },
        getFile(info){
           this.imageUrl = info.file.response.data.url;
        }
    }
}
</script>

<style>

</style>